






















































import { defineComponent, ref, reactive } from '@vue/composition-api';
import { Size } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { useTiptapEditor, EMPTY_MESSAGE } from '@front-app/components/form/tiptap/useTiptapEditor';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import EditorMenu from '@front-app/components/form/tiptap/EditorMenu.vue';
import EditorContent from '@front-app/components/form/tiptap/EditorContent.vue';
import EditorContainer from '@front-app/components/form/tiptap/EditorContainer.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';

export default defineComponent({
	components: {
		TrForm,
		FormSection,
		FormLabel,
		FormError,
		EditorMenu,
		EditorContent,
		EditorContainer,
		CtaButton,
	},
	props: {
		isSendingReply: Boolean,
	},
	setup(props, ctx) {
		const state = reactive({
			message: EMPTY_MESSAGE,
		});
		const showMessageError = ref(false);
		const el = ref(null as null | Element);
		const { editor } = useTiptapEditor(el);
		const updateMessage = () => {
			showMessageError.value = false;
			state.message = editor.getHTML();
			if (state.message === EMPTY_MESSAGE) {
				state.message = '';
			}
			ctx.emit('edit', state.message);
		};
		editor.on('blur', async () => {
			updateMessage();
			if (state.message === '') {
				showMessageError.value = true;
			}
		});
		const attemptSubmit = () => {
			updateMessage();
			if (state.message === '') {
				showMessageError.value = true;
			} else {
				ctx.emit('submit', state.message);
			}
		};
		return {
			el,
			editor,
			showMessageError,
			attemptSubmit,
			// Util
			Size,
			ButtonPalettes,
		};
	},
});
